import api from './api'
import { encryptSecureProfile, encryptSecureObject, fetchTransportPublicKey } from '@/utils/cryptoTransport'

// 用户注册
export const register = async (userData) => {
  // 兼容：若后端未配置公钥接口/浏览器不支持 WebCrypto，则回退明文 + HTTPS
  try {
    const publicKeyPem = await fetchTransportPublicKey(api)
    if (publicKeyPem && window?.crypto?.subtle) {
      const payload = { ...userData }
      if (userData?.real_name && userData?.unit_name) {
        payload.secure_profile = await encryptSecureProfile(publicKeyPem, {
          real_name: userData.real_name,
          unit_name: userData.unit_name
        })
        delete payload.real_name
        delete payload.unit_name
      }
      if (userData?.password) {
        payload.secure_passwords = await encryptSecureObject(publicKeyPem, { password: userData.password })
        delete payload.password
      }
      return api.post('/auth/register', payload)
    }
  } catch (e) {
    // ignore, fallback
  }

  return api.post('/auth/register', userData)
}

// 用户登录
export const login = async (credentials) => {
  try {
    const publicKeyPem = await fetchTransportPublicKey(api)
    if (publicKeyPem && credentials?.password && window?.crypto?.subtle) {
      const payload = { ...credentials }
      payload.secure_passwords = await encryptSecureObject(publicKeyPem, { password: credentials.password })
      delete payload.password
      return api.post('/auth/login', payload)
    }
  } catch (e) {
    // ignore, fallback
  }
  return api.post('/auth/login', credentials)
}

// 保存用户信息到本地存储
export const setUserInfo = (userInfo) => {
  localStorage.setItem('user', JSON.stringify(userInfo))
}

// 保存访问令牌到本地存储
export const setAccessToken = (token) => {
  localStorage.setItem('access_token', token)
}

// 获取本地存储的用户信息
export const getUserInfo = () => {
  const user = localStorage.getItem('user')
  return user ? JSON.parse(user) : null
}

// 获取本地存储的访问令牌
export const getAccessToken = () => {
  return localStorage.getItem('access_token')
}

// 清除本地存储的用户信息
export const clearUserInfo = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('access_token')
}

// 检查用户是否已登录
export const isAuthenticated = () => {
  return !!getAccessToken()
}

// 获取用户角色
export const getUserRole = () => {
  const user = getUserInfo()
  return user ? user.role : null
}

// 获取当前用户信息
export const getCurrentUser = () => {
  return getUserInfo()
}

// 更新用户手机号
export const updatePhone = (data) => {
  return api.put('/auth/update-phone', data)
}

// 当前用户更新个人资料（邮箱、姓名、单位等）
export const updateProfile = (payload) => {
  return api.patch('/auth/me', payload)
}